import { isNotFunction } from 'util/functions'
import * as pages from 'constants/pages'
import { CLEAR_SEARCH_TAG } from 'actions/search'
import { clearEditorAndAddBaseNode } from 'components/ConversationList/Header/Search/util'

const shouldClearEditor = (action, hadCommittedSearch) =>
  action.type === pages.TICKETS_PAGE ||
  (action.type === pages.SEARCH_PAGE &&
    action.meta?.query?.search === undefined &&
    hadCommittedSearch)

const maybeClearEditor = (action, hadCommittedSearch, editor) => {
  if (!editor || !shouldClearEditor(action, hadCommittedSearch)) return
  editor.update(clearEditorAndAddBaseNode, {
    tag: CLEAR_SEARCH_TAG,
    onUpdate: () => {
      editor.blur()
    },
  })
}

export function createSearchesMiddleware() {
  return ({ getState }) => next => action => {
    const state = getState()
    const hadCommittedSearch = !!state?.search?.committedSearchQueryString
    const editor = state?.search?.editor

    if (action?.meta?.location) {
      // eslint-disable-next-line no-param-reassign
      action.meta.previousQueryId = state?.searchV2?.currentQueryId
    }
    if (action.type === 'BATCH_ACTIONS') {
      action.actions.filter(isNotFunction).forEach(subAction => {
        if (subAction?.meta?.location) {
          // eslint-disable-next-line no-param-reassign
          subAction.meta.previousQueryId = state?.searchV2?.currentQueryId
        }
      })
    }

    const result = next(action)
    if (action.type === 'BATCH_ACTIONS') {
      action.actions
        .filter(isNotFunction)
        .forEach(subAction =>
          maybeClearEditor(subAction, hadCommittedSearch, editor)
        )
    } else {
      maybeClearEditor(action, hadCommittedSearch, editor)
    }
    return result
  }
}
